import { useCallback } from 'react';
import Delete from '../components/crud/Delete';

const DeleteView = ({
  onDeleteSubmit = () => {},
  disabled,
  isIcon = false,
  children,
}) => {
  const onSubmit = useCallback(() => {
    onDeleteSubmit();
  }, [onDeleteSubmit]);

  return (
    <Delete onDelete={onSubmit} disabled={disabled} isIcon={isIcon}>
      {children}
    </Delete>
  );
};

export default DeleteView;
